import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function BrandIntro() {
  return <section className="py-12 md:py-20 px-4 bg-cf-dark bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjEiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNSkiLz48L3N2Zz4=')]" data-id="element-43">
      <div className="max-w-4xl mx-auto text-center" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-45">
          <p className="text-cf-gold font-bold tracking-widest uppercase mb-2 text-xs md:text-base" data-id="element-46">
            RECURSOSFITNESS™ — @recursosfitness.ar
          </p>
          <p className="text-gray-400 text-[10px] md:text-sm uppercase tracking-widest mb-6 md:mb-8" data-id="element-47">
            SISTEMA N°1 PARA INSTRUCTORES DE CROSSFIT EN ARGENTINA
          </p>

          <h2 className="font-bebas text-4xl md:text-8xl text-white tracking-tight mb-3 md:mb-4 leading-[0.9]" data-id="element-48">
            MEGAPACK <br className="md:hidden" data-id="element-49" />
            <span className="text-cf-gold" data-id="element-50">CROSSFIT RESUELTO™</span>
          </h2>

          <p className="text-base md:text-3xl text-gray-300 font-medium mb-8 md:mb-12" data-id="element-51">
            6 Tomos + 6 Bonos | Todos los niveles. Todo resuelto.
          </p>
        </motion.div>

        <div className="grid grid-cols-3 gap-3 md:gap-6 mb-8 md:mb-12" data-id="element-52">
          <div className="bg-cf-card border border-white/10 p-3 md:p-6 rounded-lg" data-id="element-53">
            <p className="font-bebas text-2xl md:text-4xl text-cf-gold mb-1 md:mb-2" data-id="element-54">
              +600
            </p>
            <p className="text-gray-300 font-medium text-xs md:text-base" data-id="element-55">
              páginas de contenido estructurado
            </p>
          </div>
          <div className="bg-cf-card border border-white/10 p-3 md:p-6 rounded-lg" data-id="element-56">
            <p className="font-bebas text-2xl md:text-4xl text-cf-gold mb-1 md:mb-2" data-id="element-57">
              100+
            </p>
            <p className="text-gray-300 font-medium text-xs md:text-base" data-id="element-58">
              WODs completos y listos para programar
            </p>
          </div>
          <div className="bg-cf-card border border-white/10 p-3 md:p-6 rounded-lg" data-id="element-59">
            <p className="font-bebas text-2xl md:text-4xl text-cf-gold mb-1 md:mb-2" data-id="element-60">
              HOY
            </p>
            <p className="text-gray-300 font-medium text-xs md:text-base" data-id="element-61">
              Funciona desde hoy mismo en tu box o clases personalizadas
            </p>
          </div>
        </div>

        <div className="bg-cf-darker border border-cf-gold/20 p-5 md:p-8 rounded-xl text-left" data-id="element-62">
          <p className="text-gray-400 uppercase tracking-widest text-xs md:text-sm mb-3 md:mb-4 text-center" data-id="element-63">
            Áreas Cubiertas
          </p>
          <p className="text-sm md:text-xl text-center text-gray-200 mb-6 md:mb-8 font-medium" data-id="element-64">
            Programación · Técnica Olímpica · Escalado · Fuerza · Evaluación ·
            Gestión del Box
          </p>

          <div className="border-t border-white/10 pt-5 md:pt-6" data-id="element-65">
            <p className="text-center text-cf-gold font-bold mb-4 md:mb-6 text-sm md:text-base" data-id="element-66">
              Niveles y Enfoques Incluidos:
            </p>
            <div className="flex flex-wrap justify-center gap-2 md:gap-4" data-id="element-67">
              {['Beginner', 'Scaled', 'Rx', 'Masters 45+', 'Poblaciones especiales', 'Competencia'].map((level, i) => <div key={i} className="flex items-center gap-1.5 md:gap-2 bg-white/5 px-3 py-1.5 md:px-4 md:py-2 rounded-full border border-white/10" data-id="element-68">
                  <Check className="w-3 h-3 md:w-4 md:h-4 text-cf-gold" data-id="element-69" />
                  <span className="text-xs md:text-sm font-medium" data-id="element-70">
                    {level}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}